import { makeAutoObservable } from 'mobx';
import {
    FedexV2PinDeliveryOption,
    IFedexV2MfaOptions,
} from '../../../../../../../models/IntegrationsTypes';
import { IFedexV2MfaChanges } from './fedex-v2-credentials.types';

class FedexV2MfaStore {
    private _mfaOptions: IFedexV2MfaOptions | null = null;
    private _changes: IFedexV2MfaChanges = { pinDeliveryOption: 'EMAIL' };

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    get mfaOptions() {
        return this._mfaOptions;
    }

    get pinDeliveryOption() {
        return this._changes.pinDeliveryOption ?? 'EMAIL';
    }

    get accountAuthToken() {
        return this._changes.accountAuthToken ?? '';
    }

    get secureCodePin() {
        return this._changes.secureCodePin ?? '';
    }

    get hasSecureCodeDeliveryOptions() {
        return (this._mfaOptions?.options.secureCode || []).length > 0;
    }

    setPinDeliveryOption(value: FedexV2PinDeliveryOption) {
        this._changes.pinDeliveryOption = value;
    }

    setSecureCodePin(value: string) {
        this._changes.secureCodePin = value;
    }

    applyMfaOptions(mfaOption: IFedexV2MfaOptions) {
        this._mfaOptions = mfaOption;
        this._changes.accountAuthToken = mfaOption.accountAuthToken;
    }
}

export default FedexV2MfaStore;
